export class CartItem {
  cartItem: HTMLElement | null
  priceBase: HTMLElement | null
  priceMain: HTMLElement | null
  priceBefore: HTMLElement | null

  constructor(cartItem: HTMLElement | null) {
    this.cartItem = cartItem
    this.priceBase = cartItem?.querySelector(".i-price__base") ?? null
    this.priceMain = cartItem?.querySelector(".i-price__main") ?? null
    this.priceBefore = cartItem?.querySelector(".i-price__before") ?? null
  }

  setPriceBase(value: string) {
    if (!this.priceBase) return
    this.priceBase.innerHTML = value
  }

  setPriceMain(value: string) {
    if (!this.priceMain) return
    this.priceMain.innerHTML = value
  }

  setPriceBefore(value: string) {
    if (!this.priceBefore) return
    this.priceBefore.innerHTML = value
  }
}
